import * as types from '../actions/types'

const initState = {
  allCountries: [],
  selectedCountry: {
    name: '',
    code: '',
    phone_code: '',
    phone_length: [],
  },
}

const merchantCountries = (state = initState, action) => {
  switch (action.type) {
    case types.SET_COUNTRIES:
      return {
        ...state,
        allCountries: action.countries,
      }
    case types.SET_SELECTED_COUNTRY:
      return {
        ...state,
        selectedCountry: action.countryObj,
      }
    default:
      return state
  }
}

export default merchantCountries
